export const influencerStories = [
  {
    id: 'inf-1',
    name: '头部带货主播 M 某',
    handle: '@带货日常',
    title: '直播间售后争议：赠品规格被指与口播描述不符',
    detail:
      '有消费者整理出近期多笔订单截图，反映收到的赠品数量与规格和直播口播存在出入。主播团队在评论区回复“以商品详情页为准”，并称会逐一核实订单。',
    points: ['争议集中在赠品规格描述', '团队称以详情页信息为准', '平台规则要求如实展示促销信息'],
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20editorial%20photograph%20of%20an%20empty%20live%20streaming%20studio%20with%20ring%20lights%20and%20warm%20red%20accents%20glowing%2C%20dramatic%20contrast%20and%20soft%20film%20grain%2C%20stylized%20abstract%20ecommerce%20scene&width=900&height=700&seq=influencer-live-studio-01&orientation=landscape',
    status: '持续发酵',
    heat: '871万',
  },
  {
    id: 'inf-2',
    name: '短视频创作者 L 某',
    handle: '@创意短片',
    title: '被指搬运他人创意，原作者晒出时间线对比',
    detail:
      '原作者贴出分镜草稿与发布时间，认为两条视频的镜头调度高度相似。涉事博主回应称“纯属各自独立创作”，并表示愿意公开沟通。',
    points: ['合作拍摄还是独立创作存在分歧', '时间线截图成为讨论焦点', '平台对此类纠纷一般依据证据处理'],
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20editorial%20photograph%20of%20a%20dark%20video%20editing%20desk%20with%20warm%20amber%20screen%20glow%20and%20timeline%20monitors%2C%20dramatic%20contrast%20and%20soft%20film%20grain%2C%20stylized%20abstract%20creative%20workspace%20scene&width=900&height=700&seq=influencer-editing-desk-02&orientation=landscape',
    status: '双方各执一词',
    heat: '612万',
  },
  {
    id: 'inf-3',
    name: '美妆博主 S 某',
    handle: '@每日种草',
    title: '推广标注引发讨论：广告与分享的界线被反复提及',
    detail:
      '有粉丝指出某条内容疑似商业合作但未作明显标注。博主随后补充说明为品牌寄样，并强调不涉及付费推广，评论区讨论仍在继续。',
    points: ['商业合作是否需要显著标注', '博主称属品牌寄样', '观众更看重信息的透明与真实'],
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20editorial%20photograph%20of%20a%20vanity%20mirror%20surrounded%20by%20warm%20amber%20bulbs%20and%20blurred%20cosmetic%20bottles%2C%20dramatic%20contrast%20and%20soft%20film%20grain%2C%20stylized%20abstract%20beauty%20scene&width=900&height=700&seq=influencer-makeup-vanity-03&orientation=landscape',
    status: '话题回温',
    heat: '534万',
  },
  {
    id: 'inf-4',
    name: '探店博主 W 某',
    handle: '@城市食验',
    title: '探店视频被指滤镜过重，商家出面澄清合作细节',
    detail:
      '有网友认为视频中的食物呈现与实际观感差距较大。商家表示并未参与后期处理，博主则回应是为了画面效果做了常规调色。',
    points: ['画面呈现与真实观感的差距', '商家称未参与后期处理', '探店内容的真实性长期受关注'],
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20editorial%20photograph%20of%20a%20dim%20restaurant%20table%20with%20warm%20crimson%20lantern%20light%20and%20blurred%20dishes%2C%20dramatic%20contrast%20and%20soft%20film%20grain%2C%20stylized%20abstract%20dining%20scene&width=900&height=700&seq=influencer-restaurant-table-04&orientation=landscape',
    status: '新料补充',
    heat: '458万',
  },
];